/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, ElementRef, OnInit, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[wellWizardTabFooter]'
})
export class WizardTabFooterDirective implements OnInit {

  el = inject(ElementRef);
  renderer = inject(Renderer2);

  ngOnInit() {
    if (this.el.nativeElement?.nodeType === Node.ELEMENT_NODE) {
      this.renderer.addClass(this.el.nativeElement, 'wizard-footer');
    }
  }
}
